const URL_PATTERN = /https?:\/\/[^\s<>"']+/gi;

const trimTrailingPunctuation = (value: string) => {
  const trimmed = value.match(/^(.*?)([.,!?;:)]*)$/);
  if (!trimmed) {
    return { url: value, trailing: '' };
  }

  return { url: trimmed[1], trailing: trimmed[2] };
};

const buildAnchorHtml = (url: string) =>
  `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;

const linkifyText = (text: string) =>
  text.replace(URL_PATTERN, (rawValue) => {
    const { url, trailing } = trimTrailingPunctuation(rawValue);
    if (!url) {
      return rawValue;
    }

    return `${buildAnchorHtml(url)}${trailing}`;
  });

export const linkifyHtml = (html: string): string => {
  if (!html) {
    return html;
  }

  if (typeof window === 'undefined' || typeof DOMParser === 'undefined') {
    return linkifyText(html);
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const walker = doc.createTreeWalker(doc.body, window.NodeFilter.SHOW_TEXT);
  const textNodes: Text[] = [];

  let node = walker.nextNode();
  while (node) {
    textNodes.push(node as Text);
    node = walker.nextNode();
  }

  for (const textNode of textNodes) {
    const parentElement = textNode.parentElement;
    if (!parentElement) {
      continue;
    }

    if (parentElement.closest('a, script, style')) {
      continue;
    }

    const text = textNode.nodeValue ?? '';
    if (!URL_PATTERN.test(text)) {
      URL_PATTERN.lastIndex = 0;
      continue;
    }

    URL_PATTERN.lastIndex = 0;
    const replaced = linkifyText(text);
    if (replaced === text) {
      continue;
    }

    const wrapper = doc.createElement('span');
    wrapper.innerHTML = replaced;
    textNode.replaceWith(...Array.from(wrapper.childNodes));
  }

  return doc.body.innerHTML;
};
